export default function Loading() {
    return (
        <div className="position-absolute start-50 spinner-border" 
        style={{top: '20vw'}}></div>
    )    
}